export default {
    'gui.smalruby3.crashMessage.description': 'We are so sorry, but it looks like Smalruby has crashed. This bug has been automatically reported to the Smalruby Team. Please refresh your page to try again.',
    'gui.smalruby3.gui.defaultProjectTitle': 'Smalruby Project',
    'gui.smalruby3.gui.rubyTab': 'Ruby',
    'gui.smalruby3.previewInfo.betawelcome': 'Welcome to the Smalruby 3.0 Beta',
    'gui.smalruby3.previewInfo.label': 'Try Smalruby 3.0',
    'gui.smalruby3.previewInfo.invitation': "We're working on the next generation of Smalruby. We're excited for you to try it!",
    'gui.smalruby3.previewInfo.welcome': 'Welcome to the Smalruby 3.0 Preview',
    'gui.smalruby3.menuBar.downloadRubyCodeToComputer': 'Save Ruby to your computer',
    'gui.smalruby3.menuBar.generateRubyFromCode': 'Generate Ruby from Code',
    'gui.smalruby3.unsupportedBrowser.description': "We're very sorry, but Smalruby 3.0 does not support Internet Explorer, Vivaldi, Opera or Silk. We recommend trying a newer browser such as Google Chrome, Mozilla Firefox, or Microsoft Edge.",
    'gui.smalruby3.webglModal.description': 'Unfortunately it looks like your browser or computer {webGlLink}. This technology is needed for Smalruby 3.0 to run.',
    'gui.smalruby3.alerts.convertRubyToBlocksError': 'Could not convert Ruby to Code. Please fix Ruby!',
    'gui.smalruby3.telemetryOptIn.label': 'Report statistics to improve Smalruby',
    'gui.smalruby3.telemetryOptIn.body1': 'The Smalruby Team is always looking to better understand how Smalruby is used around the world. To help support this effort, you can allow Smalruby to automatically send usage information to the Smalruby Team.',
    'gui.smalruby3.telemetryOptIn.body2': 'The information we collect includes language selection, blocks usage, and some events like saving, loading, and uploading a project. We DO NOT collect any personal information.',
    'gui.telemetryOptIn.buttonTextNo': 'No, thanks',
    'gui.smalruby3.rubyToBlocksConverter.couldNotConvertPremitive': '"{ SOURCE }" could not be converted the block.',
    'gui.smalruby3.rubyToBlocksConverter.wrongInstruction': '"{ SOURCE }" is the wrong instruction.',
    'gui.smalruby3.telemetryOptIn.buttonTextYes': "Yes, I'd like to help improve Smalruby",
    'gui.smalruby3.extension.mesh.name': 'Mesh',
    'gui.smalruby3.extension.mesh.description': 'Allowing users to interact over a computer network.',
    'mesh.categoryName': 'Mesh',
    'mesh.sensorValue': '[NAME] sensor value',
    'mesh.hostPeripheralName': 'Mesh Host [{ MESH_ID }]',
    'mesh.clientPeripheralName': 'Join Host [{ MESH_ID }]',
    'mesh.registeredHost': 'Registered Host Mesh [{ MESH_ID }]',
    'mesh.joinedMesh': 'Joined Mesh [{ MESH_ID }]',
    'gui.smalruby3.extension.mesh.connectingMessage': 'Connecting',
    'gui.smalruby3.extension.smalrubotS1.name': 'Smalrubot S1',
    'gui.smalruby3.extension.smalrubotS1.description': 'Control the Smalrubot S1.',
    'gui.smalruby3.extension.smalrubotS1.connectingMessage': 'Connecting the Smalrubot S1',
    'smalrubotS1.categoryName': 'Smalrubot S1',
    'smalrubotS1.action': '[ACTION]',
    'smalrubotS1.actionAndStopAfter': '[ACTION] for [SECS] seconds',
    'smalrubotS1.bendArm': 'bend arm [DEGREE] degrees in [SECS] seconds',
    'smalrubotS1.getSensorValue': '[POSITION] sensor value',
    'smalrubotS1.turnLedOn': 'turn [POSITION] LED on',
    'smalrubotS1.turnLedOff': 'turn [POSITION] LED off',
    'smalrubotS1.getMotorSpeed': '[POSITION] DC motor speed (%)',
    'smalrubotS1.setMotorSpeed': 'set [POSITION] DC motor speed [SPEED] (%)',
    'smalrubotS1.setArmCalibration': 'Adjust arm [DEGREE] degrees',
    'smalrubotS1.actionMenu.forward': 'forward',
    'smalrubotS1.actionMenu.backward': 'backward',
    'smalrubotS1.actionMenu.turnLeft': 'turn left',
    'smalrubotS1.actionMenu.turnRight': 'turn right',
    'smalrubotS1.positionsMenu.left': 'left',
    'smalrubotS1.positionsMenu.right': 'right',
    'smalrubotS1.positionsMenu.touch': 'touch',
    'smalrubotS1.positionsMenu.light': 'light',
    'smalrubotS1.positionsMenu.sound': 'sound'
};
